
<template>
    <div v-if="post !== undefined" class="news page-margin-blog ">
        <div class="col-xs-12 reduce-padding">
            <div class="blog-title">{{ post.title }}</div>
            <div class='page-body section col-xs-12' v-html="post.content"></div>
        </div>
    </div>
</template>

<style scoped>
</style>

<script>
import { useRoute } from 'vue-router'

export default {
    async mounted() {
        const route = useRoute()
        const serverUrl = import.meta.env.VITE_API_URL || ''
        fetch(`${serverUrl}/api/post/${route.params.id}`)
            .then(response => response.json())
            .then(data => this.post = data);
    },

    data() {
        return {
            post: {}
        }
    }
}
</script>
